/* Licuamia · animaciones al hacer scroll para las secciones lm-* */
(function () {
  if (window.__licuamia) return;
  window.__licuamia = true;

  var root = document.documentElement;
  root.classList.add('lm-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  if (!reduce && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  function scan(scope) {
    var items = (scope || document).querySelectorAll('.lm-reveal:not(.is-in)');
    for (var i = 0; i < items.length; i++) {
      if (observer) observer.observe(items[i]);
      else items[i].classList.add('is-in');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* Editor de temas: volver a animar cuando se recarga una sección */
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
